var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1543 7.15402C7.1543 6.78888 7.26257 6.43195 7.46543 6.12835C7.66829 5.82475 7.95662 5.58812 8.29396 5.44839C8.6313 5.30866 9.0025 5.2721 9.36062 5.34334C9.71874 5.41457 10.0477 5.5904 10.3059 5.84859C10.5641 6.10678 10.7399 6.43573 10.8111 6.79385C10.8824 7.15197 10.8458 7.52317 10.7061 7.86051C10.5663 8.19785 10.3297 8.48618 10.0261 8.68904C9.72252 8.89189 9.36559 9.00017 9.00045 9.00017V10.2309",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99925 12.0767C8.81668 12.0767 8.63821 12.1308 8.48642 12.2322C8.33462 12.3337 8.2163 12.4778 8.14644 12.6465C8.07657 12.8152 8.05829 13.0008 8.09391 13.1798C8.12953 13.3589 8.21744 13.5234 8.34654 13.6525C8.47563 13.7815 8.64011 13.8695 8.81917 13.9051C8.99823 13.9407 9.18383 13.9224 9.3525 13.8525C9.52117 13.7827 9.66533 13.6644 9.76676 13.5126C9.86819 13.3608 9.92233 13.1823 9.92233 12.9997C9.91914 12.7559 9.82086 12.523 9.64844 12.3505C9.47601 12.1781 9.24307 12.0798 8.99925 12.0767Z",
    fill: "currentColor"
  })));
};
export default SvgInfo;